import { useEffect, useContext } from 'react';
import useMountedRef from '../Hooks/useMountedRef';
import ModalContext from './ModalContext';

/**
 * Gestisce il contesto delle modali passando lo stato di show.
 */
function useModalContext(open = false, options, callback = null) {
  const { setOpen, subscribe, unsubscribe } = useContext(ModalContext);
  const refMounted = useMountedRef();
  useEffect(() => {
    ModalContext.setOpenOrGlobal(open, setOpen, options);
    if (callback) ModalContext.subscribeOrGlobal(subscribe, callback);
    return () => {
      if (!refMounted.current && open) ModalContext.setOpenOrGlobal(false, setOpen, options);
      if (callback) ModalContext.unsubscribeOrGlobal(unsubscribe, callback);
    };
  }, [callback, open, options, setOpen, subscribe, unsubscribe, refMounted]);
}

export default useModalContext;
